
// Header Section Data Sets
const lastScrollTop = 0,
	delta = 15,
	headerSection = jQuery( '.header-section' ),
	heroFixedVavCtn = jQuery( '.hero-fixed-nav-ctn' ),
	topBar = jQuery( '.top-bar' ),
	navOverlay = jQuery( '.nav-overlay' ),
	body_header = jQuery( 'header,body' )
	;

jQuery.noConflict();

// adjustHeader();

// // Function to handle load event
// function handleLoad() {
// 	adjustTopBar();
// }

// // Function to handle resize event
// function handleResize() {
// 	// Check if top bar is hidden, if it is, do not show it on resize
// 	if ( ! jQuery( '.top-bar' ).hasClass( 'hide-top-bar' ) ) {
// 		adjustTopBar();
// 	}
// }

// // Function to handle click event on top bar cross
// function handleTopBarCrossClick() {
// 	hideTopBar();
// }

// // Function to adjust top bar
// function adjustTopBar() {
// 	// Your existing code to adjust top bar goes here
// }

// // Function to show top bar
// function adjustHeader() {
// 	const $topBar = jQuery( '.top-bar' );
// 	const $headerSection = jQuery( '.header-section' );
// 	const $headerInner = jQuery( '.header-inner' );

// 	$headerSection.css( 'top', '0' );
// 	jQuery( '.hero-section' ).css( 'padding-top', $headerSection.outerHeight() + 'px' );
// }

// // Function to hide top bar
// function hideTopBar() {
// 	const $topBar = jQuery( '.top-bar' );
// 	const $headerSection = jQuery( '.header-section' );
// 	const $topBarCross = jQuery( '.top-bar-cross' );

// 	$topBar.addClass( 'hide-top-bar' );
// 	$headerSection.css( 'top', '-' + $topBar.outerHeight() + 'px' );
// 	jQuery( '.hero-section' ).css( 'padding-top', $headerSection.outerHeight() - $topBar.outerHeight() + 'px' );
// }

// // Bind load event handler
// jQuery( window ).on( 'load', handleLoad );

// // Bind resize event handler
// jQuery( window ).on( 'resize', handleResize );

// // Bind click event handler for top bar cross
// jQuery( '.top-bar-cross' ).on( 'click', handleTopBarCrossClick );
